export default __webpack_public_path__ + "static/media/DIVA EX.6b487dca.jpg";